import device from "current-device";

export function game(rlxlauncher, settings) {
  let cdnbase = window.location.protocol + "//" + window.location.hostname;
  let lang;
  let url;
  let relaxsepath = "games";
  let baseurl;
  let configurl = `${settings.clientApiURL}/capi/1.0/casino/games/getlauncherconfig`;
  const getclientconfig = `${settings.clientApiURL}/capi/1.0/casino/games/getclientconfig`;
  let partner = "games";
  let partnerid = 1;
  let channelpath = "-channel-undefined-";
  let channel;
  let launchermode = "intg";
  let gameid = rlxlauncher.getData.gameid;
  let subgameid = false;
  let jurisdiction;
  let usewrapper = false;
  let previewmode = false;

  const legacygames = ["firestorm", "sinbad"];

  const nonvanilla = [
    "veikkaus",
    "playtechvfop",
    "playtechpop",
    "norsketipping",
    "norsktipping",
    "888bingo",
    "betvictor",
    "betfair",
    "paddypower",
    "gamesysuk",
    "pt-moorgate",
  ];

  const dontencode = [458, 459, 478, 479, 526, 527];

  const playtechpopDK = [500, 501, 502];

  const moorgatePartnerIds = [
    2135, 2154, 2153,
    2187, 2188, 2189, 2190, 2191, 2192, 2193, 2194, 2195, 2196, 2197, 2198, 2199, 2200, 2201, 2202, 2203, 2204, 2205, 2206, 2207, 2208, 2209, 2210, 2211, 2212, 2213, 2214, 2215, 2216, 2217, 2218, 2219, 2220, 2221, 2222, 2223, 2224,
    2167, 2169, //These two are MovingUp partner ids. We should refactor these for clarity later
    2360, 2361, 2362, //Asian Gaming
    2391, 2360, //CDNL-9 || Asian Gaming
    2387 // Niall request 11/21
  ];

  const dontencodeticket = ["dragon50000", "spiritsofthestorm"];

  const wrapperjurisdictions = ["SE", "DE"];

  const wrappername = {
    SE: "rgwrapper",
    DE: "de-wrapper",
  };

  const noDeWrapperStudios = ["Quickspin", "Push Gaming", "Kalamba"];

  const qsRegularDomains = [
    "cloudfront.net", //we expect the regular QS hosting to be on cloudfront.net ~ if not, lets use superdomain
    "amazonaws.com", //for the sake of directly accessing the amazon s3
  ];

  const ptAsiaStagingDomains = [
    "Chaofan88.com", //this was part of todo but i don't trust uppercase so made a duplicate
    "chaofan88.com",
    "liangpi88.com",
    "xiaolongbao88.com",
    "yuanxiao88.com",
    "Lamian88.com", //this was part of todo but i don't trust uppercase so made a duplicate
    "lamian88.com",
  ];

  function isUserOnStandardQSDomain() {
    var domainToCheck = window.location.hostname;
    for (let index = 0; index < qsRegularDomains.length; index++) {
      if (domainToCheck.indexOf(qsRegularDomains[index]) != -1) {
        return true;
      }
    }
    return false;
  }

  function isPreviewmode() {
    return previewmode;
  }

  function isUserOnPTAsiaStagingDomain() {
    var domainToCheck = window.location.hostname;
    for (let index = 0; index < ptAsiaStagingDomains.length; index++) {
      if (domainToCheck.indexOf(ptAsiaStagingDomains[index]) != -1) {
        return true;
      }
    }
    return false;
  }

//   if ("partner" in rlxlauncher.getData) {
//     if (rlxlauncher.getData.partner.indexOf("betvictor") == 0) {
//       if (window.location.pathname.indexOf("/cXVpY2tzcGluLXRhaXdhbg") == 0) {
//         webpath = "cXVpY2tzcGluLXRhaXdhbg/web";
//         mobilepath = "cXVpY2tzcGluLXRhaXdhbg/mobile";
//       }
//     }
//   }
  if ("channel" in rlxlauncher.getData) {
    if (rlxlauncher.getData.channel == "mobile") {
      channelpath = "mcasino";
      channel = "mobile";
    } else if (rlxlauncher.getData.channel == "web") {
      channelpath = "casino";
      channel = "web";
    } else {
      alert('Error: incorrect channel name. Please, use "web" or "mobile"');
      channelpath = "-unsupported-channel-";
    }
  }

  if ("preview" in rlxlauncher.getData) {
    if (parseInt(rlxlauncher.getData.preview) == 1) {
      previewmode = true;
    }
  }

  // No channel parameter -> using current-device.min.js
  else {
    if (device.type == "desktop") {
      channelpath = "casino";
      channel = "web";
    } else {
      channelpath = "mcasino";
      channel = "mobile";
    }
  }

  if (isUserOnStandardQSDomain()) {
    baseurl = cdnbase + "/" + channelpath;
  } else {
    const currentPath = window.location.pathname;
    const pathUpToSecondToLastDirectory = currentPath
      .split("/")
      .slice(0, -2)
      .join("/");
    baseurl = `${cdnbase}${pathUpToSecondToLastDirectory}/${channelpath}`;
  }

  if (gameid.indexOf("minigamearcade.") == 0) {
    let splitgameid = gameid.split(".");
    gameid = splitgameid[0];
    subgameid = splitgameid[1];
  }
  if ("partner" in rlxlauncher.getData) {
    if (nonvanilla.indexOf(rlxlauncher.getData.partner) != -1) {
      partner = rlxlauncher.getData.partner;
    } else if (
      channel == "mobile" &&
      legacygames.indexOf(rlxlauncher.getData.gameid) != -1
    ) {
      partner = rlxlauncher.getData.partner;
    }
  }

  if ("partnerid" in rlxlauncher.getData) {
    partnerid = rlxlauncher.getData.partnerid;
    if (
      moorgatePartnerIds.indexOf(parseInt(partnerid)) != -1 &&
      !("jurisdiction" in rlxlauncher.getData)
    ) {
      rlxlauncher.getData.jurisdiction = "pt_asia";
    }
  }

  try {
      const clientConfigRequestData = new URLSearchParams();
      clientConfigRequestData.set('gameref', gameid == "template" ? "bbw" : gameid);
      clientConfigRequestData.set('partnerid', partnerid)
      if (jurisdiction) {
        clientConfigRequestData.set('jurisdiction', jurisdiction)
      }

      const clientConfigRequest = new XMLHttpRequest();
      clientConfigRequest.open("GET", `${getclientconfig}?${clientConfigRequestData.toString()}`, false); // `false` makes the clientConfigRequest synchronous
      clientConfigRequest.send(null);
      if (clientConfigRequest.status === 200) {
        const clientConfigResponse = JSON.parse(clientConfigRequest.responseText)
        if (clientConfigResponse.theme) {
          const theme = clientConfigResponse.theme;
          const urlValue = `/themes/${partnerid}/${gameid}/${theme}`
          url += "&theme=" + encodeURIComponent(urlValue);
        }
        if (clientConfigResponse.PLAYTECH_LOADER) {
          settings.PLAYTECH_LOADER = clientConfigResponse.PLAYTECH_LOADER;
        }
      }
    } catch (error) {
      console.error(error);
    }

  if ("jurisdiction" in rlxlauncher.getData) {
    if (rlxlauncher.getData.jurisdiction.toUpperCase() == "DK") {
      if (
        partner == "playtechpop" ||
        playtechpopDK.indexOf(parseInt(partnerid)) != -1
      ) {
        partner = "playtechpop-dk";
      } else {
        partner = "games-dk";
      }
    } else if (rlxlauncher.getData.jurisdiction.toUpperCase() == "SE") {
      jurisdiction = "SE";
      relaxsepath = "games-se";
    } else if (rlxlauncher.getData.jurisdiction.toUpperCase() == "IT") {
      jurisdiction = "IT";
      if (partner == "playtechpop") {
        partner = "playtechpop-it";
      } else {
        partner = "games-it";
      }
    } else if (rlxlauncher.getData.jurisdiction == "pt_asia") {
      if (
        isPreviewmode() ||
        isUserOnPTAsiaStagingDomain() ||
        isUserOnStandardQSDomain()
      ) {
        partner = "pt-asia-staging";
      } else {
        partner = "pt-asia";
      }
    } else {
      jurisdiction = rlxlauncher.getData.jurisdiction.toUpperCase();
    }

    if (
      launchermode !== "prod" &&
      !(nonvanilla.indexOf(rlxlauncher.getData.partner) != -1)
    ) {
      if (
        rlxlauncher.getData.jurisdiction.toUpperCase() == "MT" &&
        partnerid != "14"
      ) {
        partner = "games-mt";
      } else if (rlxlauncher.getData.jurisdiction.toUpperCase() == "GG") {
        partner = "games-gg";
      }
      url =
        gameid +
        "/index.html?gameid=" +
        gameid +
        "&jurisdiction=" +
        rlxlauncher.getData.jurisdiction.toUpperCase();
    } else {
      url =
        gameid +
        "/index.html?gameid=" +
        gameid +
        "&jurisdiction=" +
        rlxlauncher.getData.jurisdiction.toUpperCase();
    }
  } else {
    url = gameid + "/index.html?gameid=" + gameid;
  }
  if (subgameid) {
    url += "&subgameid=" + subgameid;
  }
  // channel param to url
  url = url + "&channel=" + channel;

  if (rlxlauncher.getData.moneymode && rlxlauncher.getData.moneymode == "fun") {
    url = url + "&moneymode=fun";
  } else {
    url = url + "&moneymode=real";
  }

  url = url + "&partnerid=" + partnerid;
  if ("ticket" in rlxlauncher.getData) {
    if (dontencodeticket.indexOf(gameid) != -1 && partnerid == 12) {
      url += "&ticket=" + rlxlauncher.getData.ticket;
    } else {
      url = url + "&ticket=" + encodeURIComponent(rlxlauncher.getData.ticket);
    }
  }

  if ("configurl" in rlxlauncher.getData) {
    url += "&configurl=" + encodeURIComponent(rlxlauncher.getData.configurl);
  }

  if ("disableIntro" in rlxlauncher.getData) {
    url += "&disableIntro=" + rlxlauncher.getData.disableIntro;
  } else if ("disableintro" in rlxlauncher.getData) {
    url += "&disableIntro=" + rlxlauncher.getData.disableintro;
  }

  if ("lang" in rlxlauncher.getData) {
    if (rlxlauncher.getData.lang == "no_NO") {
      lang = "nb_NO";
    } else if (rlxlauncher.getData.lang.toLowerCase() == "ch") {
      lang = "zh";
    } else {
      lang = rlxlauncher.getData.lang;
    }
    url += "&lang=" + lang;
  }

  if ("currency" in rlxlauncher.getData) {
    url = url + "&currency=" + rlxlauncher.getData.currency.toUpperCase();
  }

  if ("clientid" in rlxlauncher.getData) {
    url = url + "&clientid=" + encodeURIComponent(rlxlauncher.getData.clientid);
  }

  if ("DisableFullscreen" in rlxlauncher.getData) {
    url =
      url +
      "&DisableFullscreen=" +
      encodeURIComponent(rlxlauncher.getData.DisableFullscreen);
  }

  if ("rcelapsed" in rlxlauncher.getData) {
    url = url + "&rcelapsed=" + rlxlauncher.getData.rcelapsed;
  }

  if ("rcinterval" in rlxlauncher.getData) {
    url = url + "&rcinterval=" + rlxlauncher.getData.rcinterval;
  }

  if ("rciframeurl" in rlxlauncher.getData) {
    url =
      url +
      "&rciframeurl=" +
      encodeURIComponent(rlxlauncher.getData.rciframeurl);
  }

  if ("rcenable" in rlxlauncher.getData) {
    url = url + "&rcenable=" + rlxlauncher.getData.rcenable;
  }

  if ("market" in rlxlauncher.getData) {
    url = url + "&market=" + rlxlauncher.getData.market;
  }

  if (
    "dragoffset" in rlxlauncher.getData &&
    rlxlauncher.gameid == "roulettenouveau"
  ) {
    url = url + "&dragoffset=" + rlxlauncher.getData.dragoffset;
  } else if (rlxlauncher.getData.gameid == "roulettenouveau") {
    if (partnerid == 14 || partnerid == 4) {
      url = url + "&dragoffset=40";
    }
  }

  if ("rg_panic_uri" in rlxlauncher.getData) {
    url =
      url +
      "&rg_panic_uri=" +
      encodeURIComponent(rlxlauncher.getData.rg_panic_uri);
    usewrapper = true;
  }

  if ("rg_se_uri" in rlxlauncher.getData) {
    url =
      url + "&rg_se_uri=" + encodeURIComponent(rlxlauncher.getData.rg_se_uri);
    usewrapper = true;
  }

  if ("rg_st_uri" in rlxlauncher.getData) {
    url =
      url + "&rg_st_uri=" + encodeURIComponent(rlxlauncher.getData.rg_st_uri);
    usewrapper = true;
  }

  if ("rg_sl_uri" in rlxlauncher.getData) {
    url =
      url + "&rg_sl_uri=" + encodeURIComponent(rlxlauncher.getData.rg_sl_uri);
    usewrapper = true;
  }
  if ("rg_account_uri" in rlxlauncher.getData) {
    url +=
      "&rg_account_uri=" +
      encodeURIComponent(rlxlauncher.getData.rg_account_uri);
  }
  if ("rg_opt_target" in rlxlauncher.getData) {
    url =
      url +
      "&rg_opt_target=" +
      encodeURIComponent(rlxlauncher.getData.rg_opt_target);
  }

  if ("rcshowresult" in rlxlauncher.getData) {
    url = url + "&rcshowresult=" + rlxlauncher.getData.rcshowresult;
  }

  if ("rg_embedded_frame_url" in rlxlauncher.getData) {
    url =
      url +
      "&rg_embedded_frame_url=" +
      encodeURIComponent(rlxlauncher.getData.rg_embedded_frame_url);
    usewrapper = true;
  }

  if ("rg_embedded_frame_height" in rlxlauncher.getData) {
    url =
      url +
      "&rg_embedded_frame_height=" +
      rlxlauncher.getData.rg_embedded_frame_height;
    usewrapper = true;
  }

  if ("fullscreen" in rlxlauncher.getData) {
    url = url + "&fullscreen=" + rlxlauncher.getData.fullscreen;
  }

  // PPOP
  if ("remoteusername" in rlxlauncher.getData) {
    url = url + "&remoteusername=" + rlxlauncher.getData.remoteusername;
  }

  if ("skinid" in rlxlauncher.getData) {
    url = url + "&skinid=" + rlxlauncher.getData.skinid;
  }
  if ("origin" in rlxlauncher.getData) {
    url = url + "&origin=" + rlxlauncher.getData.origin;
  }

  if ("crosslaunchurl" in rlxlauncher.getData) {
    url =
      url +
      "&crosslaunchurl=" +
      encodeURIComponent(rlxlauncher.getData.crosslaunchurl);
  }
  var hideAccountMenu = false;
  if (
    "clientplatform" in rlxlauncher.getData ||
    "clientPlatform" in rlxlauncher.getData
  ) {
    const clientPlatform =
      rlxlauncher.getData.clientplatform || rlxlauncher.getData.clientPlatform;
    if (clientPlatform.toLowerCase() == "download") {
      hideAccountMenu = true;
    }
  }
  if (
    "deliveryplatform" in rlxlauncher.getData ||
    "deliveryPlatform" in rlxlauncher.getData
  ) {
    const deliveryPlatform =
      rlxlauncher.getData.deliveryplatform ||
      rlxlauncher.getData.deliveryPlatform;
    if (deliveryPlatform.toLowerCase() == "native") {
      hideAccountMenu = true;
    }
  }

  if (hideAccountMenu == true) {
    url = url + "&HideAccountMenu=true";
  }

  if ("imsgame" in rlxlauncher.getData) {
    url = url + "&imsgame=" + rlxlauncher.getData.imsgame;
  }

  if ("superdomain" in rlxlauncher.getData) {
    url = url + "&superdomain=" + rlxlauncher.getData.superdomain;
  }

  if ("logouturl" in rlxlauncher.getData) {
    url = url + "&logouturl=" + rlxlauncher.getData.logouturl;
  }

  if ("supporturl" in rlxlauncher.getData) {
    url = url + "&supporturl=" + rlxlauncher.getData.supporturl;
  }

  // QS:
  if ("CurrencyFormattingOverride" in rlxlauncher.getData) {
    url =
      url +
      "&CurrencyFormattingOverride=" +
      encodeURIComponent(rlxlauncher.getData.CurrencyFormattingOverride);
  }

  if ("HideHomeButton" in rlxlauncher.getData) {
    url = url + "&HideHomeButton=" + rlxlauncher.getData.HideHomeButton;
  }

  if ("enablenetposition" in rlxlauncher.getData) {
    url = url + "&enableNetPosition";
  }
  if ("enableNetPosition" in rlxlauncher.getData) {
    url = url + "&enableNetPosition";
  }
  if ("cashierurl" in rlxlauncher.getData) {
    url = url + "&cashierurl=" + rlxlauncher.getData.cashierurl;
  }
  if ("popclient_urlopen" in rlxlauncher.getData) {
    url = url + "&popclient_urlopen=" + rlxlauncher.getData.popclient_urlopen;
  }
  if ("qsclient_urlopen" in rlxlauncher.getData) {
    url = url + "&popclient_urlopen=" + rlxlauncher.getData.qsclient_urlopen;
  }

  if (partner == "betfair") {
    url += "&leovegas";
  }

  if (isUserOnStandardQSDomain() == false) {
    var server_search = /\.(\w*.*)/.exec(window.location.hostname);
    if (server_search != null && server_search[1] != undefined) {
      url = url + "&superdomain=" + server_search[1];
    }
  }

  if (wrapperjurisdictions.indexOf(jurisdiction) == -1) {
    if ("homeurl" in rlxlauncher.getData) {
      if (dontencode.indexOf(parseInt(rlxlauncher.getData.partnerid)) != -1) {
        url = url + "&homeurl=" + rlxlauncher.getData.homeurl;
      } else {
        url =
          url + "&homeurl=" + encodeURIComponent(rlxlauncher.getData.homeurl);
      }
    }

    if ("rchistoryurl" in rlxlauncher.getData) {
      url =
        url +
        "&rchistoryurl=" +
        encodeURIComponent(rlxlauncher.getData.rchistoryurl);
    }
    if ("gamehistoryurl" in rlxlauncher.getData) {
      url =
        url +
        "&rchistoryurl=" +
        encodeURIComponent(rlxlauncher.getData.gamehistoryurl);
    }
    return baseurl + "/" + partner + "/" + url;
  } else {
    const req = new XMLHttpRequest();
    const cu = configurl;
    req.open("POST", cu, true);
    req.setRequestHeader("Content-Type", "application/json");
    let data = {
      gameref: gameid,
    };
    req.timeout = 5000;
    req.ontimeout = function () {
      alert("Error: Game studio query Timed Out.");
    };
    req.send(JSON.stringify(data));
    req.onreadystatechange = function () {
      if (req.readyState === 4 && req.status === 200) {
        const launcherconfig = JSON.parse(req.responseText);
        if (launcherconfig.studio == "Quickspin") {
          if ("homeurl" in rlxlauncher.getData) {
            if (
              dontencode.indexOf(parseInt(rlxlauncher.getData.partnerid)) != -1
            ) {
              url = url + "&homeurl=" + rlxlauncher.getData.homeurl;
            } else {
              url =
                url +
                "&homeurl=" +
                encodeURIComponent(rlxlauncher.getData.homeurl);
            }
          }

          if ("rchistoryurl" in rlxlauncher.getData) {
            url =
              url +
              "&rchistoryurl=" +
              encodeURIComponent(rlxlauncher.getData.rchistoryurl);
          }
          if ("gamehistoryurl" in rlxlauncher.getData) {
            url =
              url +
              "&rchistoryurl=" +
              encodeURIComponent(rlxlauncher.getData.gamehistoryurl);
          }

          if (!("rcshowresult" in rlxlauncher.getData)) {
            url = url + "&rcshowresult=false";
          }
          return baseurl + "/" + partner + "/" + url;
        } else {
          if (channel == "mobile") {
            url = url + "&fullscreen=false";
          }
          if (
            jurisdiction == "DE" &&
            noDeWrapperStudios.indexOf(launcherconfig.studio) == -1
          ) {
            usewrapper = true;
          }
          if (usewrapper == true) {
            url = url.replace("?", "&");
            if ("homeurl" in rlxlauncher.getData) {
              if (rlxlauncher.getData.homeurl.substring(0, 7) == "action:") {
                url =
                  url +
                  "&homeurl=" +
                  encodeURIComponent(rlxlauncher.getData.homeurl);
              } else {
                url =
                  url +
                  "&homeurl=" +
                  encodeURIComponent("action:") +
                  encodeURIComponent(rlxlauncher.getData.homeurl);
              }
            }

            if ("rchistoryurl" in rlxlauncher.getData) {
              if (
                rlxlauncher.getData.rchistoryurl.substring(0, 7) == "action:"
              ) {
                url =
                  url +
                  "&rchistoryurl=" +
                  encodeURIComponent(rlxlauncher.getData.rchistoryurl);
              } else {
                url =
                  url +
                  "&rchistoryurl=" +
                  encodeURIComponent("action:") +
                  encodeURIComponent(rlxlauncher.getData.rchistoryurl);
              }
            }
            if ("gamehistoryurl" in rlxlauncher.getData) {
              url =
                url +
                "&rchistoryurl=" +
                encodeURIComponent(rlxlauncher.getData.gamehistoryurl);
            }
            return (
              cdnbase +
              "/casino/" +
              wrappername[jurisdiction] +
              "/?gameUrl=" +
              baseurl +
              "/" +
              relaxsepath +
              "/" +
              url
            );
          } else {
            if ("homeurl" in rlxlauncher.getData) {
              url =
                url +
                "&homeurl=" +
                encodeURIComponent(rlxlauncher.getData.homeurl);
            }

            if ("rchistoryurl" in rlxlauncher.getData) {
              url =
                url +
                "&rchistoryurl=" +
                encodeURIComponent(rlxlauncher.getData.rchistoryurl);
            }
            if ("gamehistoryurl" in rlxlauncher.getData) {
              url =
                url +
                "&rchistoryurl=" +
                encodeURIComponent(rlxlauncher.getData.gamehistoryurl);
            }
            return baseurl + "/" + relaxsepath + "/" + url;
          }
        }
      }
    };
  }
}
